import { useState } from "react";
import Cropper from "react-easy-crop";
import MessageDialogWithActions from "components/MessageDialogWithActions";
import { Button, ButtonSecondary } from "components/Buttons";
import { PrinterIcon } from "@heroicons/react/outline";

function PremierPhotoDialog({ handleClose, fulfilment }) {
  const photoUrl = fulfilment.photoUrl;

  // const paperSize = { w: 148, h: 105 }; // a6
  const paperSize = { w: 105, h: 74 }; // a7 (print in the middle of an a6)

  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [mediaSize, setMediaSize] = useState(null);

  const cropEl = document.querySelector(".reactEasyCrop_CropArea");
  const fit =
    mediaSize?.width && mediaSize?.height
      ? {
          w: cropEl.offsetHeight / mediaSize.height,
          h: cropEl.offsetWidth / mediaSize.width,
        }
      : null;

  return (
    <MessageDialogWithActions
      wide
      name="PremierPhotoDialog"
      message={
        <div className="h-96 min-h-fit min-w-fit">
          <div className="relative w-full h-full">
            <Cropper
              image={photoUrl}
              crop={crop}
              zoom={zoom}
              minZoom={0.5}
              maxZoom={4}
              aspect={paperSize.w / paperSize.h}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onMediaLoaded={(m) => {
                setMediaSize(m);
              }}
            />
          </div>
        </div>
      }
      actionLineAdditionalContent={
        <div className="flex-1 border flex h-16 items-center">
          <div className="flex-0 w-24 text-center">
            {(zoom * 100).toFixed(2)}%
          </div>
          <div className="btn-group flex-shrink-0">
            {fit.h && (
              <Button onClick={() => setZoom(fit.h)}>Fit height</Button>
            )}
            {fit.w && <Button onClick={() => setZoom(fit.w)}>Fit width</Button>}
          </div>
          <input
            type="range"
            value={zoom}
            min={0.5}
            max={4}
            step={0.1}
            aria-labelledby="Zoom"
            onChange={(e) => {
              setZoom(e.target.value);
            }}
            className="range range-xs mx-4"
          />
        </div>
      }
      actions={[
        {
          text: "Cancel",
          colour: "red",
          onClick: handleClose,
        },
      ]}
    />
  );
}

function PremierPhotoDialogButton({ fulfilment }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      {open && (
        <PremierPhotoDialog
          fulfilment={fulfilment}
          handleClose={() => setOpen(false)}
        />
      )}
      <ButtonSecondary onClick={() => setOpen(true)}>
        <PrinterIcon className="size-6 inline-block" />
        &nbsp;Print&hellip;
      </ButtonSecondary>
    </>
  );
}

export default PremierPhotoDialogButton;
